import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, BARCODE_LENGTH, DataType, DEFAULT_KEYPAD_MAX_COL, EMPTY_STRING, LoadingMessages, SystemParameter } from "src/app/common/Const";
import { ME000002, ME100010, ME200003, ME200005, ME200007, ME200008, MI100001, MI200001, MI200002, MQ200002, MQ200005, MQ200006, MQ200010, MQ200011 } from "src/app/common/const-message-id";
import { GC_D0046_CANCELLED, GC_D0046_VALID, GC_D2016_NORMAL_SLIP, GC_D2087_APPROVED, GC_D2087_REJECTED, GC_D2087_REQUESTING } from "src/app/common/ConstCcd";
import { GC_H2086_DISCARD_TRANS_TYPE } from "src/app/common/ConstCcdDef";
import { TableColumnDef } from "src/app/common/table-column-def";
import { BarcodeDialogComponent } from "src/app/dialog/barcode-dialog/barcode-dialog.component";
import { ErrorNotificationDialogComponent } from "src/app/dialog/error-notification-dialog/error-notification-dialog.component";
import { Spmt10311DetailDialogComponent } from "src/app/dialog/spmt10311-detail-dialog/spmt10311-detail-dialog.component";
import { Spmt10311SlipListDialogComponent } from "src/app/dialog/spmt10311-slip-list-dialog/spmt10311-slip-list-dialog.component";
import { BarcodeButtonComponent } from "src/app/partsCommon/barcode-button/barcode-button.component";
import { NumberKeypadComponent } from "src/app/partsCommon/number-keypad/number-keypad.component";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqGetStoreList } from "src/app/request/req-get-store-list";
import { ReqSpmt10311Confirm } from "src/app/request/req-spmt10311-confirm";
import { ReqSpmt10311Search } from "src/app/request/req-spmt10311-search";
import { ReqTmt790GetAllSystemParam } from "src/app/request/req-tmt790-get-all-system-param";
import { Rsp } from "src/app/response/rsp";
import { GetStoreListDto } from "src/app/response/rsp-get-store-list";
import { RspSpmt10311ProductSearch, RspSpmt10311SlipSearch, Spmt10311HeaderDto, Spmt10311SearchRowDto } from "src/app/response/rsp-spmt10311-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

interface TableRow extends Spmt10311SearchRowDto {
  form: {
    checkForm: FormControl;
    disposalReasonForm: FormControl;
    dtQtyForm: FormControl;
    slipDtlCommentForm: FormControl;
  };
}

interface Header extends Spmt10311HeaderDto {
  form: {
    slipCommentForm: FormControl;
    disposalDateForm: FormControl;
  };
}

interface Spmt10311TableColumnDef extends TableColumnDef {
  type?: string;
}

enum ColumnIds {
  Check = "check",
  ProductCd = "productCd",
  ProductNm = "productNm",
  StandardNm = "standardNm",
  DisposalReason = "disposalReason",
  DtQty = "dtQty",
  CostExc = "costExc",
  CostAmtExc = "costAmtExc",
  SellPriceExc = "sellPriceExc",
  SellPriceAmtExc = "sellPriceAmtExc",
  GMainClassNm = "gMainClassNm",
  GMidClassNm = "gMidClassNm",
  GSmallClassNm = "gSmallClassNm",
  GSubClassNm = "gSubClassNm",
  SlipDtlComment = "slipDtlComment",
  SlipDtlApproverComment = "slipDtlApproverComment",
}

enum ColumnHeaders {
  Check = "削除",
  ProductCd = "商品コード",
  ProductNm = "商品名称",
  StandardNm = "規格",
  DisposalReason = "廃棄理由",
  DtQty = "数量",
  CostExc = "原単価(抜)",
  CostAmtExc = "原価金額(抜)",
  SellPriceExc = "売単価(抜)",
  SellPriceAmtExc = "売価金額(抜)",
  GMainClassNm = "大分類",
  GMidClassNm = "中分類",
  GSmallClassNm = "小分類",
  GSubClassNm = "細分類",
  SlipDtlComment = "伝票詳細コメント",
  SlipDtlApproverComment = "伝票詳細承認者コメント",
}

class Constant {
  public static readonly STORE_CD_CTRL: string = "storeCd";
  public static readonly SLIP_NO_CTRL: string = "slipNo";
  public static readonly PRODUCT_CD_CTRL: string = "productCd";
  public static readonly NON_DIGIT_REGEX = /\D/g;

  public static readonly DT_QTY_LABEL = "数量";

  public static readonly DT_QTY_MIN = 1;
}

@Component({
  selector: "app-spmt10311",
  templateUrl: "./spmt10311.component.html",
  styleUrls: ["./spmt10311.component.css"],
})
export class Spmt10311Component implements OnInit, AfterViewInit {
  roundMode: string = "";
  maxQuantity: number = 0;
  dataSource = new MatTableDataSource<TableRow>([]);
  detailData: Header;
  columnIds: string[] = [
    ColumnIds.Check,
    ColumnIds.ProductCd,
    ColumnIds.ProductNm,
    ColumnIds.StandardNm,
    ColumnIds.DisposalReason,
    ColumnIds.DtQty,
    ColumnIds.CostExc,
    ColumnIds.CostAmtExc,
    ColumnIds.SellPriceExc,
    ColumnIds.SellPriceAmtExc,
    ColumnIds.GMainClassNm,
    ColumnIds.GMidClassNm,
    ColumnIds.GSmallClassNm,
    ColumnIds.GSubClassNm,
    ColumnIds.SlipDtlComment,
    ColumnIds.SlipDtlApproverComment,
  ];
  public columnDefsItems: Spmt10311TableColumnDef[] = [
    { columnId: ColumnIds.Check, header: ColumnHeaders.Check, width: 45, align: Alginment.Center, checkbox: true, type: DataType.CHECKBOX },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 95, align: Alginment.Left, editable: true, type: DataType.LINK },
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 200, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 95, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.DisposalReason, header: ColumnHeaders.DisposalReason, width: 95, align: Alginment.Left, type: DataType.DROPDOWN_LIST },
    { columnId: ColumnIds.DtQty, header: ColumnHeaders.DtQty, width: 70, align: Alginment.Right, type: DataType.INPUT_NUMBER },
    { columnId: ColumnIds.CostExc, header: ColumnHeaders.CostExc, width: 150, numberPipe: "1.2-2" },
    { columnId: ColumnIds.CostAmtExc, header: ColumnHeaders.CostAmtExc, width: 150, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SellPriceExc, header: ColumnHeaders.SellPriceExc, width: 150, numberPipe: "1.2-2" },
    { columnId: ColumnIds.SellPriceAmtExc, header: ColumnHeaders.SellPriceAmtExc, width: 150, numberPipe: "1.0-0" },
    { columnId: ColumnIds.GMainClassNm, header: ColumnHeaders.GMainClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GMidClassNm, header: ColumnHeaders.GMidClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GSmallClassNm, header: ColumnHeaders.GSmallClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GSubClassNm, header: ColumnHeaders.GSubClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.SlipDtlComment, header: ColumnHeaders.SlipDtlComment, width: 180, align: Alginment.Left, type: DataType.INPUT_TEXT },
    { columnId: ColumnIds.SlipDtlApproverComment, header: ColumnHeaders.SlipDtlApproverComment, width: 180, align: Alginment.Left, type: DataType.TEXT },
  ];

  public access: ReqAccess = {
    ...this.commonService.loginUser,
  };
  public storeCdList: GetStoreListDto[] = [];
  public slipKbnList: KbnSearchDto[] = [];
  public itemTableWidth: any;
  public tableWidth: any;

  checkAllControl: FormControl;
  isShowSearchCondition = true;
  isDisabledDelBtn = true;

  public searchCondition: FormGroup;
  @ViewChild("searchProductCode", { static: true }) searchProductCode: ElementRef;
  @ViewChild("keypad", { static: true }) numberKeypadComponent: NumberKeypadComponent;
  @ViewChild(BarcodeButtonComponent) barcodeButtonComponent: BarcodeButtonComponent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(public commonService: CommonService, public httpBasic: HttpBasicService, private readonly message: MessageService, private readonly fb: FormBuilder) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.searchCondition = this.fb.group(
      {
        storeCd: [EMPTY_STRING, Validators.required],
        slipNo: [EMPTY_STRING],
        productCd: [EMPTY_STRING],
      },
      {
        validators: this.atLeastOneFilled(Constant.SLIP_NO_CTRL, Constant.PRODUCT_CD_CTRL),
      }
    );

    this.detailData = {
      ...this.detailData,
      slipNo: EMPTY_STRING,
      approverComment: EMPTY_STRING,
      form: {
        slipCommentForm: new FormControl(EMPTY_STRING),
        disposalDateForm: new FormControl(EMPTY_STRING, Validators.required),
      },
    };

    this.checkAllControl = new FormControl(false);
    this.calcTableWidth();
    this.fnGetAccessInfo();
    this.set10KeyPadTarget(this.searchCondition.get(Constant.PRODUCT_CD_CTRL) as FormControl);
  }

  btnSearchClick() {
    if (!this.searchCondition.valid) {
      return;
    }
    if (this.dataSource.data.length > 0 && (this.searchCondition.value.storeCd != this.detailData.storeCd || this.searchCondition.value.slipNo != this.detailData.slipNo)) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200011]).subscribe((result) => {
        if (result) {
          this.dataSource.data = [];
          this.fnClearResult();
          this.fnSearch();
        }
      });
      return;
    }
    this.fnSearch();
  }

  fnSearch() {
    const request = this.fnGetRequestForSearch();
    if (this.searchCondition.value.slipNo && this.detailData.slipNo !== this.searchCondition.value.slipNo) {
      this.fnSearchSlip(request);
    } else {
      this.fnSearchProduct(request);
    }
  }

  private fnGetRequestForSearch(): ReqSpmt10311Search {
    const condition = this.searchCondition.value;
    return {
      access: this.access,
      ...condition,
      disposalDate: this.commonService.dateToString(this.detailData.form.disposalDateForm.value),
    };
  }

  private fnSearchSlip(request: ReqSpmt10311Search): void {
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10311SlipSearch(request).subscribe({
      next: (response: RspSpmt10311SlipSearch) => {
        if (this.httpBasic.handleAppError(response)) return;
        if (response.rows.length === 0) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
          return;
        }
        this.detailData = {
          ...response.header,
          slipNo: response.header.slipNo ?? EMPTY_STRING,
          approverComment: response.header.approverComment ?? EMPTY_STRING,
          form: {
            slipCommentForm: new FormControl(response.header.slipComment),
            disposalDateForm: new FormControl(response.header.disposalDate, Validators.required),
          },
        };
        this.dataSource.data = response.rows.map((row) => ({
          ...row,
          form: {
            checkForm: new FormControl({ value: false, disabled: !this.isValidReqStatus() }),
            dtQtyForm: new FormControl({ value: row.dtQty, disabled: !this.isValidReqStatus() }),
            disposalReasonForm: new FormControl({ value: row.disposalReason, disabled: !this.isValidReqStatus() }),
            slipDtlCommentForm: new FormControl({ value: row.slipDtlComment, disabled: !this.isValidReqStatus() }),
          },
        }));
        this.checkAllControl.setValue(false);
        if (request.productCd) {
          request.disposalDate = response.header.disposalDate;
          this.fnSearchProduct(request);
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  private fnSearchProduct(request: ReqSpmt10311Search): void {
    if ((this.detailData.reqStatus && (this.detailData.reqStatus === GC_D2087_APPROVED || this.detailData.reqStatus === GC_D2087_REJECTED)) || this.detailData.slipCancelFlg === GC_D0046_CANCELLED) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME200008]);
      return;
    }

    if (!request.productCd) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME000002].replace("%1", "商品コード入力"));
      this.searchProductCode.nativeElement.focus();
      return;
    }
    const productCode = request.productCd;
    const existingProduct = this.dataSource.data.filter((item) => item.productCd === productCode);

    if (existingProduct.length === this.slipKbnList.length) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME200007]?.replace("%1", "廃棄・振替他一覧"));
      this.searchProductCode.nativeElement.focus();
      return;
    }

    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10311ProductSearch(request).subscribe({
      next: (response: RspSpmt10311ProductSearch) => {
        this.fnHandleProductSearchResponse(response);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  fnHandleProductSearchResponse(response: RspSpmt10311ProductSearch) {
    if (this.httpBasic.handleAppError(response)) return;
    if (!response?.row?.productCd) {
      this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
      return;
    }
    if (
      this.detailData.slipNo &&
      (this.detailData.tradeTaxKbn !== response.row.tradeTaxKbn || this.detailData.taxRate !== response.row.taxRate || this.detailData.taxRateCd !== response.row.taxRateCd)
    ) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200005]).subscribe((result) => {
        const createNewSlip = (result: boolean) => {
          if (!result) return;
          this.fnClearResult();
          this.searchCondition.get(Constant.SLIP_NO_CTRL).setValue(EMPTY_STRING);
          this.fnShowPopupDetail(response.row);
        };

        const cancelOperation = (result: boolean) => {
          if (result) return;
          this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
          this.searchProductCode.nativeElement.focus();
        };

        createNewSlip(result);
        cancelOperation(result);
      });
      return;
    }
    this.fnShowPopupDetail(response.row);
  }

  fnShowPopupDetail(product: Spmt10311SearchRowDto): void {
    this.detailData.storeCd = this.searchCondition.value.storeCd;
    const dialogRef = this.commonService.dialog.open(Spmt10311DetailDialogComponent, {
      autoFocus: false,
      data: {
        maxQuantity: this.maxQuantity,
        access: this.access,
        slipKbnList: this.slipKbnList,
        detailData: this.detailData,
        existsReasons: this.dataSource.data.filter((item) => item.productCd === product.productCd).map((item) => item.form.disposalReasonForm.value),
        product,
        btnTitle: "追加",
      },
    });

    dialogRef.afterClosed().subscribe((data: Spmt10311SearchRowDto) => {
      if (data) {
        this.dataSource.data = [
          ...this.dataSource.data,
          {
            ...data,
            costAmtExc: this.commonService.roundNumber(data.costExc * data.dtQty, 0, this.roundMode),
            sellPriceAmtExc: this.commonService.roundNumber(data.sellPriceExc * data.dtQty, 0, this.roundMode),
            form: {
              checkForm: new FormControl(false),
              disposalReasonForm: new FormControl(data.disposalReason),
              dtQtyForm: new FormControl(data.dtQty),
              slipDtlCommentForm: new FormControl(data.slipDtlComment),
            },
          },
        ];
        this.detailData.storeCd = this.detailData.storeCd || this.searchCondition.value.storeCd;
        this.detailData.slipNo = this.detailData.slipNo || this.searchCondition.value.slipNo;
        this.checkAllControl.setValue(false);
      }
      this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
      this.searchProductCode.nativeElement.focus();
    });
  }

  btnClearClick() {
    if (this.dataSource.data.length > 0) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200010]).subscribe((result) => {
        if (result) {
          this.fnClear();
        }
      });
      return;
    }
    this.fnClear();
  }

  checkDtQty(formControl: FormControl, item: TableRow, el?: HTMLInputElement) {
    if (!formControl.value) {
      this.fnShowError(this.message.message[ME100010], el);
    } else if (formControl.value < 1 || formControl.value > this.maxQuantity) {
      this.fnShowError(this.message.message[ME200005]?.replace("%1", Constant.DT_QTY_LABEL).replace("%2", Constant.DT_QTY_MIN.toString()).replace("%3", this.maxQuantity.toString()), el);
    }
    item.costAmtExc = this.commonService.roundNumber(item.costExc * parseInt(formControl.value), 0, this.roundMode);
    item.sellPriceAmtExc = this.commonService.roundNumber(item.sellPriceExc * parseInt(formControl.value), 0, this.roundMode);
  }

  private fnShowError(errorMessage: string, el?: HTMLInputElement) {
    el?.blur();
    const dialogRef = this.commonService.dialog.open(ErrorNotificationDialogComponent, {
      data: {
        errorMessage: errorMessage,
        errorTitle: this.commonService.pageTitle,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      el?.focus();
      el?.setSelectionRange(el?.value.length, el?.value.length);
    });
  }

  btnConfirmClick(): void {
    if (!this.isValidReqStatus()) return;
    if (!this.detailData.form.disposalDateForm.value) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME000002].replace("%1", "廃棄日"));
      return;
    }
    this.searchProductCode.nativeElement.focus();
    if (this.dataSource.data.length > 0) {
      for (let i = 0; i < this.dataSource.data.length; i++) {
        const formControl = this.dataSource.data[i].form.dtQtyForm;
        if (!formControl.value) {
          const message = `レコード番号: ${i + 1}<br/>` + this.message.message[ME200003]?.replace("%1", Constant.DT_QTY_LABEL);
          this.commonService.openErrorDialog(this.commonService.pageTitle, message);
          return;
        }
        if (formControl.value < 1 || formControl.value > this.maxQuantity) {
          const message =
            `レコード番号: ${i + 1}<br/>` +
            this.message.message[ME200005]?.replace("%1", Constant.DT_QTY_LABEL).replace("%2", Constant.DT_QTY_MIN.toString()).replace("%3", this.maxQuantity.toString());
          this.commonService.openErrorDialog(this.commonService.pageTitle, message);
          return;
        }
      }
      const dialogRef = this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200006]);
      dialogRef.subscribe((data) => {
        if (data) {
          this.fnConfirm();
        }
      });
    }
  }

  private fnConfirm(): void {
    const request: ReqSpmt10311Confirm = this.fnGetRequestForRegistUpdate();
    this.httpBasic.beforeRequestStart(LoadingMessages.Registing);
    this.httpBasic.spmt10311Confirm(request).subscribe({
      next: (data: Rsp) => {
        if (this.httpBasic.handleAppError(data)) return;
        this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200002]);
        this.fnClear();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  fnGetRequestForRegistUpdate(): ReqSpmt10311Confirm {
    return {
      access: this.access,
      header: {
        ...{
          ...this.detailData,
          form: undefined,
        },
        slipComment: this.detailData.form.slipCommentForm.value,
        disposalDate: this.commonService.dateToString(this.detailData.form.disposalDateForm.value),
      },
      rows: this.dataSource.data.map((row) => ({
        ...row,
        changeFlg: row.dtQty != row.form.dtQtyForm.value || row.disposalReason != row.form.disposalReasonForm.value || row.slipDtlComment != row.form.slipDtlCommentForm.value,
        dtQty: row.form.dtQtyForm.value,
        disposalReason: row.form.disposalReasonForm.value,
        slipDtlComment: row.form.slipDtlCommentForm.value,
        form: undefined,
      })),
    };
  }

  isExistsDisposalReason(item: TableRow, dataCd: string): boolean {
    return item.form.disposalReasonForm.value === dataCd || this.dataSource.data.findIndex((i: TableRow) => i.productCd === item.productCd && i.form.disposalReasonForm.value === dataCd) == -1;
  }

  onChangeRowCheck() {
    this.checkAllControl.setValue(this.dataSource.data.length > 0 && this.dataSource.data.filter((item) => item.form.checkForm.value).length === this.dataSource.data.length);
  }

  checkAll($event: any): void {
    this.dataSource.data.forEach((item) => {
      item.form.checkForm.setValue($event.checked);
    });
  }

  fnIsDisableDeleteButton(): boolean {
    const res = this.dataSource.data.length == 0 || this.dataSource.data.filter((item) => item.form.checkForm.value).length == 0;
    return res;
  }

  fnIsDisableConfirmButton(): boolean {
    const isChangeTable = this.dataSource.data.some(
      (item) =>
        !item.systemSlipDetailNo ||
        (item.systemSlipDetailNo && (item.dtQty != item.form.dtQtyForm.value || item.disposalReason != item.form.disposalReasonForm.value || item.slipDtlComment != item.form.slipDtlCommentForm.value))
    );
    const isChangeHeader = this.detailData.form.slipCommentForm.value != this.detailData.slipComment;
    const isEnable = this.dataSource.data.length > 0 && (isChangeTable || isChangeHeader) && this.isValidReqStatus();
    return !isEnable;
  }

  btnDeleteClick(): void {
    this.searchProductCode.nativeElement.focus();
    if (!this.fnIsDisableDeleteButton()) {
      const dialogRef = this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200002]);
      dialogRef.subscribe((result) => {
        if (result) {
          this.fnDeleteList();
        }
      });
    }
  }

  fnDeleteList(): void {
    this.checkAllControl.setValue(this.dataSource.data.length > 0 && this.dataSource.data.filter((item) => item.form.checkForm.value).length === this.dataSource.data.length);
    const request = this.fnGetRequestForDelete();
    if (request.rows.length == 0) {
      this.execDelete();
      return;
    }
    this.httpBasic.beforeRequestStart(LoadingMessages.Deleting);
    this.httpBasic.spmt10311Confirm(request).subscribe({
      next: (response: Rsp) => {
        if (this.httpBasic.handleAppError(response)) return;
        this.execDelete();
        if (this.dataSource.data.length !== 0) {
          const storeCd = this.detailData.storeCd;
          const slipNo = this.detailData.slipNo;
          this.fnClear();
          this.searchCondition.patchValue({
            storeCd,
            slipNo,
            productCd: "",
          });
          this.fnSearch();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  execDelete() {
    this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200001]);
    this.dataSource.data = this.dataSource.data.filter((item: TableRow) => !item.form.checkForm.value);
    this.checkAllControl.setValue(false);
    if (this.dataSource.data.length === 0) {
      this.fnClear();
    }
  }

  fnGetRequestForDelete(): ReqSpmt10311Confirm {
    return {
      access: this.access,
      header: {
        ...{
          ...this.detailData,
          form: undefined,
        },
      },
      deleteFlg: true,
      rows: this.dataSource.data
        .filter((item) => item.systemSlipDetailNo)
        .map((row) => ({
          ...row,
          deleteFlg: row.form.checkForm.value,
          form: undefined,
        })),
    };
  }

  fnClear(): void {
    this.searchCondition.reset();
    this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
    this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
    this.searchProductCode.nativeElement.focus();

    this.fnClearResult();
  }

  private fnClearResult() {
    this.detailData = {
      form: {
        disposalDateForm: new FormControl(EMPTY_STRING, Validators.required),
        slipCommentForm: new FormControl(EMPTY_STRING),
      },
    };

    this.checkAllControl.setValue(false);
    this.dataSource.data = [];
  }

  onClickLink(item: TableRow) {
    this.fnShowPopupDetailLink(item);
  }

  fnShowPopupDetailLink(item: TableRow): void {
    const dialogRef = this.commonService.dialog.open(Spmt10311DetailDialogComponent, {
      autoFocus: false,
      data: {
        maxQuantity: this.maxQuantity,
        access: this.access,
        slipKbnList: this.slipKbnList,
        detailData: this.detailData,
        existsReasons: this.dataSource.data
          .filter((row) => row.productCd === item.productCd && row.form.disposalReasonForm !== item.form.disposalReasonForm)
          .map((row) => row.form.disposalReasonForm.value),
        product: {
          ...item,
          disposalReason: item.form.disposalReasonForm.value,
          dtQty: item.form.dtQtyForm.value,
          slipDtlComment: item.form.slipDtlCommentForm.value,
        },
        btnTitle: "更新",
      },
    });

    dialogRef.afterClosed().subscribe((data: Spmt10311SearchRowDto) => {
      if (data) {
        item.costAmtExc = this.commonService.roundNumber(data.costExc * data.dtQty, 0, this.roundMode);
        item.sellPriceAmtExc = this.commonService.roundNumber(data.sellPriceExc * data.dtQty, 0, this.roundMode);
        item.form.disposalReasonForm.setValue(data.disposalReason);
        item.form.dtQtyForm.setValue(data.dtQty);
        item.form.slipDtlCommentForm.setValue(data.slipDtlComment);
      }
      this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
      this.searchProductCode.nativeElement.focus();
    });
  }

  isValidReqStatus(): boolean {
    return (
      (!this.detailData.reqStatus || this.detailData.reqStatus === GC_D2087_REQUESTING) &&
      (!this.detailData.redBlackFlg || this.detailData.redBlackFlg === GC_D2016_NORMAL_SLIP) &&
      (!this.detailData.slipCancelFlg || this.detailData.slipCancelFlg === GC_D0046_VALID)
    );
  }

  fnGetAccessInfo() {
    let req: Req = {
      access: this.access,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getUserInfo(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length > 0) {
          this.access.cmpnyCd = res.rows[0].mainCmpnyCd;
          this.access.storeCd = res.rows[0].mainStoreCd;
          this.access.sysModeCd = res.rows[0].sysModeCd;
          this.access.lang = res.rows[0].mainLang;
          this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
          this.initScreen();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  initScreen() {
    this.getStoreList();
    this.getKbnList();
    this.getSystemParam();
  }

  private getSystemParam() {
    let request: ReqTmt790GetAllSystemParam = {
      access: this.access,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.tmt790GetAllSystemParam(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        const maxQuantity = res.rows.find((row) => row.key === SystemParameter.CM0007)?.value;
        const roundMode = res.rows.find((row) => row.key === SystemParameter.ST0007)?.value;
        if (maxQuantity) {
          this.maxQuantity = Number(maxQuantity);
        }
        this.roundMode = roundMode;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getKbnList() {
    const rcdKbns = [GC_H2086_DISCARD_TRANS_TYPE];
    const request = {
      access: this.access,
      rcdKbns,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    return this.httpBasic.tmt050AllKbnSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.slipKbnList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getStoreList() {
    let request: ReqGetStoreList = {
      access: this.access,
      storeCd: EMPTY_STRING,
      userId: EMPTY_STRING,
      cmpyCd: this.access.cmpnyCd,
      sysModeCd: this.access.sysModeCd,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getStoreList(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.storeCdList = res.rows;
        this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  atLeastOneFilled(ctrl1: string, ctrl2: string) {
    return (formGroup: FormControl) => {
      const control1 = formGroup.get(ctrl1);
      const control2 = formGroup.get(ctrl2);
      const isValid = !!control1?.value || !!control2?.value;

      return isValid ? null : { atLeastOneFilled: true };
    };
  }

  calcTableWidth() {
    this.tableWidth = { width: "100%" };
  }

  isKeyboardLocked() {
    return this.numberKeypadComponent.isKeyboardLocked() ?? false;
  }

  checkIs10KeyPadTarget(ctrl: string) {
    return this.is10KeyPadTarget(this.searchCondition.get(ctrl) as FormControl);
  }

  is10KeyPadTarget(ctrl: FormControl): boolean {
    return ctrl === this.numberKeypadComponent.inputField;
  }

  setKeyPad(control: string, maxCol: number = DEFAULT_KEYPAD_MAX_COL, stringMode: boolean = false) {
    if (maxCol === BARCODE_LENGTH) {
      this.barcodeButtonComponent.forcusIn();
    }
    this.set10KeyPadTarget(this.searchCondition.get(control) as FormControl, maxCol, stringMode);
  }

  targetTableRow: TableRow;
  set10KeyPadTarget(control: FormControl, maxCol: number = DEFAULT_KEYPAD_MAX_COL, stringMode: boolean = false, item?: TableRow) {
    if (maxCol === BARCODE_LENGTH && this.barcodeButtonComponent) {
      this.barcodeButtonComponent.forcusIn();
    }
    if (!this.commonService.config.use10KeyPad) {
      return;
    }
    this.targetTableRow = item;
    this.numberKeypadComponent.setTargetForm(control);
    this.numberKeypadComponent.setMaxCol(maxCol);
    this.numberKeypadComponent.setStringMode(stringMode);
  }

  openErrDialog(msg: string) {
    this.commonService.dialog.open(ErrorNotificationDialogComponent, {
      data: {
        errorMessage: msg,
        errorTitle: this.commonService.pageTitle,
      },
    });
  }

  onScan(barcode: string) {
    if (barcode) {
      this.fnExecAfterScan(barcode);
    }
  }

  private fnExecAfterScan(barcode: string) {
    let productCd = barcode;
    if (this.commonService.config.loginBarcode) {
      productCd = barcode.substring(this.commonService.config.loginBarcode.start, this.commonService.config.loginBarcode.end);
    }
    productCd = productCd.replace(Constant.NON_DIGIT_REGEX, EMPTY_STRING);
    this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(productCd);
    if (productCd) {
      const request = this.fnGetRequestForSearch();
      this.fnSearchProduct(request);
    }
  }

  openBarcodeDialog() {
    const dialogRef = this.commonService.dialog.open(BarcodeDialogComponent, {
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data != undefined && data != null) {
        this.fnExecAfterScan(data);
      }
    });
  }

  fnClearTargetForm() {
    this.numberKeypadComponent.setTargetForm(undefined);
  }

  btnListSlipNoClick(): void {
    const dialogRef = this.commonService.dialog.open(Spmt10311SlipListDialogComponent, {
      autoFocus: false,
      data: {
        access: { ...this.access },
        storeCd: this.searchCondition.get(Constant.STORE_CD_CTRL).value,
        storeNm: this.storeCdList.find((x: GetStoreListDto) => x.storeCd == this.searchCondition.get(Constant.STORE_CD_CTRL).value).storeDetail,
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.slipNo !== this.searchCondition.get(Constant.SLIP_NO_CTRL).value) {
        this.searchCondition.get(Constant.SLIP_NO_CTRL).setValue(data.slipNo);
        this.btnSearchClick();
      }
    });
  }

  isCheckboxAllDisabled() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => item.form.checkForm.disabled);
  }

  onValueChange(value: string) {
    if (!this.targetTableRow) return;
    this.checkDtQty(this.targetTableRow.form.dtQtyForm, this.targetTableRow);
  }
}
